var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons"},[_c('span',{staticClass:"btn btn-bordered-red"},[_vm._v("Request Pricing")]),_c('span',{staticClass:"btn btn-bordered-blue"},[_vm._v("Request One-to-One Demo")])])
}]

export { render, staticRenderFns }